import { useEffect, useState } from "react";
import "./LoginComponent.css";
import NextBtn from "../../../../Shared/Components/NextBtn/NextBtn";
import { useNavigate } from "react-router-dom";
import { verifyOtp, resendOtp } from "../../../../Actions/UserActions";
import { PhoneAuthProvider, signInWithCredential } from "firebase/auth";

import {
  getMobileNumber,
  saveConsentFlag,
  saveOnboardingFlag,
  setUserProfileData,
  setUserToken,
  stopPlayingAudio,
  setUserType,
  setAgents,
  setUserKb,
  setUserCadre,
  setUserApproach,
  setUserId,
  setTooltip,
  getTooltip,
  handleTooltipOnboarding,
  CheckLanguageSupport,
} from "../../../../Actions/Utils";
import { auth } from "../../../../firebaseConfig";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { generateSpeech } from "../../../../Actions/ChatActions";
import CountdownTimer from "../../../../Shared/Components/CountdownTimer/CountdownTimer";
import ToastMessage from "../../../../Shared/Components/ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../../NewConstants/ToastConstants";
import platform from "platform";
import {trackEvent} from "../../../../Actions/Utils";
import { getOtpSentLabel, loginAudio, loginConstant, loginErrorLabels } from "../../../../NewConstants/LoginConstant";
import { guideButtons } from "../../../../NewConstants/GuideConstant";
import { deploymentNeGD } from "../../../../NewConstants/DeploymentConstants";
import { getDeployment } from "../../../../Actions/Utils";

const LoginComponent = ({ selectedLanguage, audioRef, setStepIndex, setStartTour, onBack }) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [showErrorFlag, setShowErrorFlag] = useState(false);
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [requestController] = useState(null);
  const mobileNumber = getMobileNumber();
  const timerLength = 1;
  const [resendOtpFlag, setResendOtpFlag] = useState(false);
  const [showTimerFlag, setShowTimerFlag] = useState(true);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [captchaSolved, setCaptchaSolved] = useState(false);
  const isIframe = getDeployment() === deploymentNeGD;

  // Get or create a singleton RecaptchaVerifier bound to the current DOM node
  const generateRecaptcha = async () => {
    try {
      // If an instance already exists, reset and reuse it
      if (window.recaptchaVerifier) {
        setCaptchaSolved(false);
        try {
          // Ensure it's rendered and then reset the widget
          await window.recaptchaVerifier.render();
          window.recaptchaVerifier.reset();
        } catch (e) {
          // If render throws due to already rendered, a reset is still attempted
          try { window.recaptchaVerifier.reset(); } catch (_) {}
        }
        return window.recaptchaVerifier;
      }

      // Create a new verifier if one doesn't exist
      const container = document.getElementById('recaptcha-container');
      if (!container) {
        throw new Error('reCAPTCHA container not found');
      }
      container.innerHTML = '';

      setCaptchaSolved(false);
      const verifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
        size: 'invisible',
        callback: () => {
          setCaptchaSolved(true);
        },
        'expired-callback': () => {
          setCaptchaSolved(false);
        }
      });
      await verifier.render();
      window.recaptchaVerifier = verifier;
      return verifier;
    } catch (error) {
      console.error("Error generating recaptcha:", error);
      setToastErrorMessage('Error setting up verification. Please try again.');
      setShowToastMessage(true);
      throw error;
    }
  };

  useEffect(() => {
    stopPlayingAudio(audioRef);
    window.history.pushState(null, document.title, window.location.href);

    const handlePopState = (event) => {
      window.history.pushState(null, document.title, window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [audioRef]);

  // Send OTP on initial mount with a fresh Recaptcha verifier
  const sendInitialOtp = async (mobileNumber) => { // Pass mobileNumber as argument
    try {
      const appVerifier = await generateRecaptcha();
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        "+91" + mobileNumber,
        appVerifier
      );
      sessionStorage.setItem(
        "verificationId",
        confirmationResult.verificationId
      );
      // In case callback timing differs, ensure OTP input becomes enabled
      // Only set captchaSolved to true if the reCAPTCHA callback hasn't already done so.
      if (!captchaSolved) {
        setCaptchaSolved(true);
      }
    } catch (error) {
      console.error("Error sending initial OTP:", error);
      setToastErrorMessage("Error sending OTP. Please try again.");
      setShowToastMessage(true);
    }
  };

  useEffect(() => {
    if (mobileNumber) {
      sendInitialOtp(mobileNumber); // Call with mobileNumber
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileNumber]); // Depend on mobileNumber

  // Cleanup recaptcha on unmount
  useEffect(() => {
    return () => {
      if (window.recaptchaVerifier) {
        try { window.recaptchaVerifier.clear(); } catch (e) { /* noop */ }
        window.recaptchaVerifier = null;
      }
    };
  }, []);

  
  const goToNext = async (data) => {
    setAgents(data?.agents);
    setTooltip(data?.tooltip_data);
    if (data?.agents.length <= 0){
      navigate("/login");
    }else{
      if (data?.type === "Internal" && data?.agents.length > 1){
        navigate("/kb-selection");
      }else{
        const agent = data.agents[0];
        setUserCadre(agent?.cadre);
        setUserKb(agent?.kb);
        setUserApproach(agent?.approach);
        saveOnboardingFlag(agent?.onboarding);
        saveConsentFlag(agent?.consent);
        if (!agent?.onboarding){
          navigate("/guide");
        }else if (!agent?.consent && !isIframe){
          navigate("/consent");
        }else{
          await navigateBasedOnSupport();
        }
      }
    }
  };

  const optTimeoutOccured = () => {
    setShowTimerFlag(false);
    setResendOtpFlag(true);
  };

  const handleOtpChange = (e) => {
    setShowErrorFlag(null);
    const value = e.target.value.replace(/\D/g, ''); // Remove any non-digits
    // Only allow exactly 6 digits or less while typing
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  const verifyOtpFun = async () => {
    setIsLoading(true);
    try {
      // ✅ Get verificationId from sessionStorage
      const storedVerificationId = sessionStorage.getItem("verificationId");
      if (!storedVerificationId) {
        setToastErrorMessage("Session expired. Please try again.");
        setShowToastMessage(true);
        navigate("/login");
        return;
      }
      // ✅ Generate Firebase credentials using verificationId + OTP
      const credential = PhoneAuthProvider.credential(storedVerificationId, otp);
      // ✅ Sign in with the credential
      const firebaseCredential = await signInWithCredential(auth, credential);
      if (firebaseCredential.user) {
        const deviceData = {
          device_name: platform.manufacturer || "Unknown",
          device_os: platform.os?.family || "Unknown",
          device_version: platform.os?.version || "Unknown",
        };
  
        const browserData = {
          browser_name: platform.name || "Unknown",
          browser_version: platform.version || "Unknown",
        };

        const res = await verifyOtp(
          mobileNumber,
          firebaseCredential._tokenResponse.idToken,
          deviceData,
          browserData,
          selectedLanguage
        );
  
        if (res?.status === 200) {
          if (res?.data?.token) {
            setUserToken(res?.data?.token);
            res["data"]["user_data"]["mobile"] = mobileNumber;
            setUserType(res?.data?.user_data?.type);
            setUserProfileData(res?.data?.user_data?.profile);
            setUserId(res?.data?.user_data?.user_id);

            // Show success toast message
            setToastErrorMessage("OTP verification successful!");
            setShowToastMessage(true);

            goToNext(res?.data?.user_data);

            // Track successful login
            trackEvent("Login Process", "Success", "Login Successfully");
          }
        } else if (res?.status === 401) {
          setShowErrorFlag(true);
          trackEvent("Login Process", "Failed", "Invalid OTP");
        } else if (res?.status === 500) {
          setToastErrorMessage(res?.data?.detail);
          setShowToastMessage(true);
          trackEvent("Login Process", "Failed", "Server Error");
        } else if (res?.status === 400) {
          setToastErrorMessage(res?.data?.detail);
          setShowToastMessage(true);
          trackEvent("Login Process", "Failed", "Bad Request");
        }
      }
    } catch (error) {
      console.error("Firebase verification error:", error);
      setShowErrorFlag(true);
      setToastErrorMessage("Invalid OTP. Please try again.");
      setShowToastMessage(true);
      trackEvent("Login Process", "Failed", "Firebase Verification Failed");
    } finally {
      setIsLoading(false);
    }
  };

  const resendOtpFun = async () => {
    setIsLoading(true);
    setShowErrorFlag(false);
    setResendOtpFlag(false);
    setShowTimerFlag(true);
    setOtp("");

    try {
      // Always create a fresh Recaptcha instance to avoid stale DOM references
      const appVerifier = await generateRecaptcha();
      const confirmationResult = await signInWithPhoneNumber(auth, "+91" + mobileNumber, appVerifier);
      sessionStorage.setItem('verificationId', confirmationResult.verificationId);

      // Call backend resend OTP API
      const res = await resendOtp(`+91${mobileNumber}`);
      if (res?.status === 200) {
        setResendOtpFlag(false);
        trackEvent("Login Process", "Resend OTP", "Success");
      } else if (res?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      } else if (res?.status === 500) {
        setToastErrorMessage(res?.data?.detail);
        setShowToastMessage(true);
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      setToastErrorMessage("Error sending OTP. Please try again.");
      setShowToastMessage(true);
      trackEvent("Login Process", "Resend OTP", "Failed");
      
      // Reset recaptcha on error
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleAudio = async () => {
      const res = await generateSpeech(
        loginAudio[selectedLanguage],
        selectedLanguage
      );
      if (res?.data?.url) {
        const newAudio = new Audio(res?.data?.url);
        if (audioRef.current) {
          audioRef.current.pause();
        }
        if (requestController) {
          requestController.abort();
        }

        newAudio.addEventListener("ended", () => {
          setShowSpeakerActive(false);
        });

        audioRef.current = newAudio;
        newAudio.play().catch((err) => {
          console.error("Error playing audio:", err);
        });
      } else {
        setToastErrorMessage(res?.data?.detail);
        setShowToastMessage(true);
        setShowSpeakerActive(false);
      }
    };
    if (showSpeakerActive) handleAudio();
  }, [showSpeakerActive, audioRef, requestController, selectedLanguage]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };
    if (!mobileNumber) {
      navigate("/login");
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [audioRef, mobileNumber, navigate]);
  const navigateBasedOnSupport = async () => {
    const route = await CheckLanguageSupport();
    if (route === "chat"){
      const tooltip = getTooltip();
      handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
      navigate("/chat");
    }else if (route === "language-check"){
      navigate("/language-check");
    }else{
      navigate("/login");
    }
  };

  return (
    <>
      <div className="loginComponent">
        <div className="flex w-[100%] flex-col items-center justify-center px-4 pt-2">
          <div className="flex items-center justify-between w-full">
            <div className="loginNextBtn   ">
              <NextBtn
                icon={"/Assets/Images/arrowLeftBlack.svg"}
                nextClick={() => onBack()}
              />
            </div>
            <div
              className={`speakerDiv ${showSpeakerActive ? "Active" : ""}`}
              onClick={() => {
                setShowSpeakerActive(!showSpeakerActive);
                stopPlayingAudio(audioRef);
              }}
            >
              {showSpeakerActive ? guideButtons.stop[selectedLanguage] : null}
              {showSpeakerActive ? (
                <div className="">
                  <img
                    src={"/Assets/Images/blueSpeaker.svg"}
                    alt="active Speaker"
                  />
                </div>
              ) : (
                <div className="">
                  <img
                    src={"/Assets/Images/crossSpeakerIcon.svg"}
                    alt="speaker"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="loginInputComponent">
          <div className="flex flex-col items-center justify-center">
            <img className="ml-[3rem]" src={"/Assets/Images/otpPageIcon.svg"} alt="otpheadinglabel" />
            <div className="flex flex-col items-center justify-center w-[90%] pt-[2rem] pb-8">
              <div className="text-[2rem] text-black font-[600] pb-2">
                {loginConstant.otpTitle[selectedLanguage]}
              </div>
              <div className="flex flex-col items-center">
                <div className="text-[1rem] text-gray-500 text-center">
                  {getOtpSentLabel(mobileNumber, selectedLanguage)}
                </div>
                <div>
                  {showTimerFlag && (
                    <CountdownTimer
                      timerLength={timerLength}
                      timeoutOccured={optTimeoutOccured}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex gap-1 items-center mb-2">
              <img src={"/Assets/Images/passwordIcon.svg"} alt="password" />
              <label>
                {loginConstant.pass[selectedLanguage]}{" "}
                {/* <span className="text-[var(--dark-neutral-2)]">
                  {loginConstant.passSpan[selectedLanguage]}
                </span> */}
              </label>
            </div>
            <input
              className={`text-xl tracking-[0.6rem] inputfield focus:ring-blue-500 focus:border-blue-500 border ${
                showErrorFlag
                  ? "border-[var(--red-1)]"
                  : "border-[var(--dark-neutral-1)]"
              }`}
              type="tel"
              placeholder="000000"
              required
              minLength={6}
              maxLength={6}
              pattern="[0-9]{6}"
              inputMode="numeric"
              value={otp}
              onChange={handleOtpChange}
              disabled={!captchaSolved}
            />
            {!captchaSolved && (
              <div className="text-sm text-[var(--dark-neutral-2)]">
                {loginConstant.verifyingCaptcha?.[selectedLanguage] || "Verifying you are human..."}
              </div>
            )}
            {showErrorFlag && (
              <div className="flex items-center text-[var(--red-1)]">
                <img src="./Assets/Images/alertCircle.svg" alt="alertcircle" />
                <span className="pl-2 text-lg">
                  {loginErrorLabels.otp[selectedLanguage]}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="loginNextBtn">
          {otp.length === 6 && !resendOtpFlag && (
            <NextBtn
              value={isLoading ? loginConstant.verifying[selectedLanguage] : loginConstant.proceedButton[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              nextClick={verifyOtpFun}
              padx={48}
              disabled={isLoading}
            />
          )}
          {resendOtpFlag && (
            <NextBtn
              value={isLoading ? loginConstant.sending[selectedLanguage] : loginConstant.resendOtp[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              nextClick={resendOtpFun}
              padx={48}
              disabled={isLoading}
            />
          )}
        </div>
        {/* Invisible reCAPTCHA container */}
        <div id="recaptcha-container"></div>
      </div>
      {showToastMessage && (
        <ToastMessage
          message={toastErrorMessage}
          severity={ToastSeverityMap.error}
          direction={"bottom"}
          close={setShowToastMessage}
        />
      )}
    </>
  );
};

export default LoginComponent;
